import {Divider, Form, Input, InputNumber, Select, Switch} from 'antd';
import React from "react";
import {IFieldOptionsEditorProps} from "../../FieldOptionsEditor";
import ActionPicker from "../../../../../../shared/pickers/ActionPicker";
import EmployeesService from "../../../../../../../model/service/company/EmployeesService";
import IContentType from "../../../../../../../model/interface/dataStorage/IContentType";
import LocaleText from "../../../../../settings/dictionary/LocaleText";

export interface ICompositeFieldCoordinatesOptions {
    current?: boolean,
    pick?: boolean
    showMap?: boolean
    manual?: boolean
    mapHeight?: number
    mapWidth?: number
    presenter?: 'map' | 'coordinates' | 'map-coordinates'
    presenterHeight?: string | number
    presenterWidth?: string | number
}

interface IProps extends IFieldOptionsEditorProps {
    contentType: IContentType
}

interface IState {
    format?: string
    type?: string
}

class CompositeFieldCoordinatesOptionsEditor extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {};
    }

    static getDefaultOptions(): ICompositeFieldCoordinatesOptions {
        return {
            current: true,
            showMap: true,
            pick: true
        }
    }

    render() {
        const {parent, buildFieldName} = this.props

        return (
            <div>
                {(!parent || parent === 'form') && (
                    <>
                        <Form.Item name={buildFieldName('current')} label={<LocaleText code={'configuration.field.coordinates.options.current'} fallback={'Možnost vybrat aktuální polohu'}/>} valuePropName={'checked'}>
                            <Switch/>
                        </Form.Item>
                        <Form.Item name={buildFieldName('pick')} label={<LocaleText code={'configuration.field.coordinates.options.pick'} fallback={'Možnost ručního výběru na mapě'}/>} valuePropName={'checked'}>
                            <Switch/>
                        </Form.Item>
                        <Form.Item name={buildFieldName('pick')} label={<LocaleText code={'configuration.field.coordinates.options.pick'} fallback={'Možnost ručního výběru na mapě'}/>} valuePropName={'checked'}>
                            <Switch/>
                        </Form.Item>
                        <Form.Item name={buildFieldName('manual')} label={<LocaleText code={'configuration.field.coordinates.options.manual'} fallback={'Možnost zadat ručně'}/>} valuePropName={'checked'}>
                            <Switch/>
                        </Form.Item>
                        <Form.Item name={buildFieldName('showMap')} label={<LocaleText code={'configuration.field.coordinates.options.show-map'} fallback={'Zobrazit mapu'}/>} valuePropName={'checked'}>
                            <Switch/>
                        </Form.Item>
                        <Form.Item name={buildFieldName('mapHeight')} label={<LocaleText code={'configuration.field.coordinates.options.map-height'} fallback={'Výška mapy'}/>}>
                            <InputNumber min={10}/>
                        </Form.Item>
                        <Form.Item name={buildFieldName('mapWidth')} label={<LocaleText code={'configuration.field.coordinates.options.map-width'} fallback={'Šířka mapy'}/>}>
                            <InputNumber min={10}/>
                        </Form.Item></>
                )}
                {(!parent || parent === 'card') && (
                    <div>
                        <Divider type={"horizontal"}><LocaleText code={'configuration.field.coordinates.options.presenter-map-coordinates'} fallback={'Zobrazení'}/></Divider>
                        <Form.Item name={buildFieldName('presenter')} label={<LocaleText code={'configuration.field.coordinates.options.presenter'} fallback={'Zobrazeni'}/>}>
                            <Select>
                                <Select.Option value={'map'}>
                                    <LocaleText code={'configuration.field.coordinates.options.presenter-map'} fallback={'Mapa'}/>
                                </Select.Option>
                                <Select.Option value={'coordinates'}>
                                    <LocaleText code={'configuration.field.coordinates.options.presenter-coordinates'} fallback={'Souradnice'}/>
                                </Select.Option>
                                <Select.Option value={'map-coordinates'}>
                                    <LocaleText code={'configuration.field.coordinates.options.presenter-map-coordinates'} fallback={'Mapa a souradnice'}/>
                                </Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item name={buildFieldName('presenterHeight')} label={<LocaleText code={'configuration.field.coordinates.options.presenter-height'} fallback={'Výška zobrazení mapy'}/>}>
                            <Input/>
                        </Form.Item>
                        <Form.Item name={buildFieldName('presenterWidth')} label={<LocaleText code={'configuration.field.coordinates.options.presenter-width'} fallback={'Šířka zobrazení mapy'}/>}>
                            <Input/>
                        </Form.Item>
                    </div>
                )}
            </div>
        )
    }
}


export default CompositeFieldCoordinatesOptionsEditor